import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Merge = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.889 0H3.206C1.503 0 0 1.5 0 3.2v37.5C0 42.5 1.503 44 3.207 44h37.581c1.804 0 3.207-1.5 3.207-3.2V3.2c.1-1.7-1.403-3.2-3.106-3.2ZM21.046 41.9H3.206c-.6 0-1.202-.5-1.202-1.2V3.2c0-.6.501-1.2 1.203-1.2h17.839v39.9Zm20.945-1.1c0 .6-.501 1.2-1.203 1.2H23.05V2.1h17.738c.602 0 1.203.5 1.203 1.2v37.5Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.438 22c0 .3-.1.5-.3.7L13.93 26c-.4.4-1.102.4-1.503 0-.401-.4-.401-1.1 0-1.5l1.403-1.4H6.715c-.602 0-1.003-.5-1.003-1s.501-1 1.003-1h7.115l-1.403-1.4c-.401-.4-.401-1.1 0-1.5.4-.4 1.102-.4 1.503 0l3.207 3.2c.2.1.3.3.3.6ZM38.383 22c0 .6-.501 1-1.002 1h-7.116l1.404 1.4c.4.4.4 1.1 0 1.5-.401.4-1.103.4-1.504 0l-3.207-3.2c-.2-.2-.3-.5-.3-.7 0-.2.1-.5.3-.7l3.207-3.2c.401-.4 1.103-.4 1.504 0 .4.4.4 1.1 0 1.5L30.265 21h7.116c.601 0 1.002.4 1.002 1Z"
  }));
});
Merge.displayName = 'Merge';
Merge.defaultProps = {
  'aria-label': 'Merge'
};
export default Merge;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Editor/Merge.js
// module id = 2933
// module chunks = 11